



































































import Vue from 'vue';
import {useRouter} from '@/router';
import Button, {ButtonTypes} from '@common/button/button.vue';
import SkeletonWrapper from '@common/skeleton-wrapper.vue';
import {getTripType} from '@/store/state/helpers';
import {ToggleComponent} from '@mobi-components/toggle';
import BaseCard from './base-card.vue';

export default Vue.extend({
  components: {
    Button,
    SkeletonWrapper,
    ToggleComponent,
    BaseCard,
  },
  name: 'TripSummaryFlightCard',
  props: {
    category: String,
    title: String,
    subTitle: {
      type: String,
      default: null,
    },
    images: Array,
    matchPercent: Number,
    priceLabel: String,
    price: String,
    showMatchAndPrice: {type: Boolean, default: () => true},
    isLoading: Boolean,
    detailsRoute: String,
    selectRoute: String,
    label: String,
    isFlightsOn: Boolean,
  },
  data() {
    return {
      ButtonTypes,
    };
  },
  computed: {
    categoryClassName(): string {
      return `trip-summary-card category-${this.category?.toLowerCase() || 'none'}`;
    },
    imagesList(): string[] {
      return (this.images as string[]) || [''];
    },
    labelParts(): string[] {
      return this.label.split(':');
    },
    tripWayType(): string {
      return getTripType();
    },
    getSubTitle(): string {
      return this.isFlightsOn ? this.subTitle : 'Flights turned Off';
    },
    getTitle(): string {
      return this.isFlightsOn ? this.title : 'Set your Arrival Time';
    },
  },
  methods: {
    onDetailsClick() {
      const router = useRouter();
      router.push(this.detailsRoute);

      this.$emit('details-click');
    },
    onSelectClick() {
      const router = useRouter();
      router.push(this.selectRoute);

      this.$emit('select-click');
    },
    onToggle() {
      this.$emit('toggle-flight');
    },
    onSetArrival() {
      this.$emit('set-arrival');
    },
  },
});
